<panel>
  <menu>
    @for (item of menuItems; track item) {
      <menuitem (click)="item.action()">@if (item.icon) {
        <icon [type]="item.icon" />
      }{{ item.text }}</menuitem>
    }
  </menu>
  <h1>Test list med context menu</h1>
  <list-view>
    <header>header 1</header>
    <header>header 2</header>
    <header>header 3</header>
    <row *listData="let rowData from rowDataList">
      <column [sortValue]="rowData.dateColumn">{{ rowData.dateColumn | customDate: 'shortDate' }}</column>
      <column>{{ rowData.stringColumn }}</column>
      <column [sortValue]="rowData.currenctColumn">{{ rowData.currenctColumn | currency }}</column>
      <menu>
        <menuitem (click)="test(rowData.stringColumn)">Kopier</menuitem>
        <menuitem (click)="test(rowData.stringColumn)">Slet</menuitem>
      </menu>
    </row>
  </list-view>
</panel>

<panel>
  <h1>Test list med context menu</h1>
  <list-view>
    <header>header 1</header>
    <header>header 2</header>
    <header>header 3</header>
    <row *listData="let rowData from rowDataList">
      <column [sortValue]="rowData.dateColumn">{{ rowData.dateColumn | customDate: 'shortDate' }}</column>
      <column>{{ rowData.stringColumn }}</column>
      <column [sortValue]="rowData.currenctColumn">{{ rowData.currenctColumn | currency }}</column>
    </row>
  </list-view>
  <menu>
    @for (item of menuItems; track item) {
      <menuitem (click)="item.action()">{{ item.text }}</menuitem>
    }
  </menu>
</panel>
